// source: accounts/protos/invoice_dto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var accounts_protos_payment_dto_pb = require('../../accounts/protos/payment_dto_pb.js');
goog.object.extend(proto, accounts_protos_payment_dto_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.accounts.protos.InvoiceDTO', null, global);
goog.exportSymbol('proto.accounts.protos.InvoiceDTO.BackendDataCase', null, global);
goog.exportSymbol('proto.accounts.protos.InvoiceDataStripeDTO', null, global);
goog.exportSymbol('proto.accounts.protos.InvoiceItemDTO', null, global);
goog.exportSymbol('proto.accounts.protos.InvoiceRelationsDTO', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.InvoiceDataStripeDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.InvoiceDataStripeDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.InvoiceDataStripeDTO.displayName = 'proto.accounts.protos.InvoiceDataStripeDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.InvoiceItemDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.InvoiceItemDTO.repeatedFields_, null);
};
goog.inherits(proto.accounts.protos.InvoiceItemDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.InvoiceItemDTO.displayName = 'proto.accounts.protos.InvoiceItemDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.InvoiceRelationsDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.InvoiceRelationsDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.InvoiceRelationsDTO.displayName = 'proto.accounts.protos.InvoiceRelationsDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.InvoiceDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.InvoiceDTO.repeatedFields_, proto.accounts.protos.InvoiceDTO.oneofGroups_);
};
goog.inherits(proto.accounts.protos.InvoiceDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.InvoiceDTO.displayName = 'proto.accounts.protos.InvoiceDTO';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.InvoiceDataStripeDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.InvoiceDataStripeDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.InvoiceDataStripeDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceDataStripeDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    link: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.InvoiceDataStripeDTO}
 */
proto.accounts.protos.InvoiceDataStripeDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.InvoiceDataStripeDTO;
  return proto.accounts.protos.InvoiceDataStripeDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.InvoiceDataStripeDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.InvoiceDataStripeDTO}
 */
proto.accounts.protos.InvoiceDataStripeDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.InvoiceDataStripeDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.InvoiceDataStripeDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.InvoiceDataStripeDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceDataStripeDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string link = 1;
 * @return {string}
 */
proto.accounts.protos.InvoiceDataStripeDTO.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceDataStripeDTO} returns this
 */
proto.accounts.protos.InvoiceDataStripeDTO.prototype.setLink = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDataStripeDTO} returns this
 */
proto.accounts.protos.InvoiceDataStripeDTO.prototype.clearLink = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDataStripeDTO.prototype.hasLink = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.InvoiceItemDTO.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.InvoiceItemDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.InvoiceItemDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceItemDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    label: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    amount: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
    proration: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.accounts.protos.InvoiceItemDTO.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.InvoiceItemDTO}
 */
proto.accounts.protos.InvoiceItemDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.InvoiceItemDTO;
  return proto.accounts.protos.InvoiceItemDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.InvoiceItemDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.InvoiceItemDTO}
 */
proto.accounts.protos.InvoiceItemDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProration(value);
      break;
    case 5:
      var value = new proto.accounts.protos.InvoiceItemDTO;
      reader.readMessage(value,proto.accounts.protos.InvoiceItemDTO.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.InvoiceItemDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.InvoiceItemDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceItemDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.accounts.protos.InvoiceItemDTO.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.setLabel = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.clearLabel = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.hasLabel = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float amount = 3;
 * @return {number}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.setAmount = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.clearAmount = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool proration = 4;
 * @return {boolean}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.getProration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.setProration = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.clearProration = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.hasProration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated InvoiceItemDTO items = 5;
 * @return {!Array<!proto.accounts.protos.InvoiceItemDTO>}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.accounts.protos.InvoiceItemDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accounts.protos.InvoiceItemDTO, 5));
};


/**
 * @param {!Array<!proto.accounts.protos.InvoiceItemDTO>} value
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
*/
proto.accounts.protos.InvoiceItemDTO.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.accounts.protos.InvoiceItemDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.InvoiceItemDTO}
 */
proto.accounts.protos.InvoiceItemDTO.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.accounts.protos.InvoiceItemDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.InvoiceItemDTO} returns this
 */
proto.accounts.protos.InvoiceItemDTO.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.InvoiceRelationsDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.InvoiceRelationsDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.InvoiceRelationsDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceRelationsDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    planFirewallId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.InvoiceRelationsDTO}
 */
proto.accounts.protos.InvoiceRelationsDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.InvoiceRelationsDTO;
  return proto.accounts.protos.InvoiceRelationsDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.InvoiceRelationsDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.InvoiceRelationsDTO}
 */
proto.accounts.protos.InvoiceRelationsDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanFirewallId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.InvoiceRelationsDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.InvoiceRelationsDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.InvoiceRelationsDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceRelationsDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string plan_firewall_id = 1;
 * @return {string}
 */
proto.accounts.protos.InvoiceRelationsDTO.prototype.getPlanFirewallId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceRelationsDTO} returns this
 */
proto.accounts.protos.InvoiceRelationsDTO.prototype.setPlanFirewallId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceRelationsDTO} returns this
 */
proto.accounts.protos.InvoiceRelationsDTO.prototype.clearPlanFirewallId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceRelationsDTO.prototype.hasPlanFirewallId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.InvoiceDTO.repeatedFields_ = [9];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.accounts.protos.InvoiceDTO.oneofGroups_ = [[10]];

/**
 * @enum {number}
 */
proto.accounts.protos.InvoiceDTO.BackendDataCase = {
  BACKEND_DATA_NOT_SET: 0,
  STRIPE_DATA: 10
};

/**
 * @return {proto.accounts.protos.InvoiceDTO.BackendDataCase}
 */
proto.accounts.protos.InvoiceDTO.prototype.getBackendDataCase = function() {
  return /** @type {proto.accounts.protos.InvoiceDTO.BackendDataCase} */(jspb.Message.computeOneofCase(this, proto.accounts.protos.InvoiceDTO.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.InvoiceDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.InvoiceDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.InvoiceDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    type: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    label: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    settledAt: (f = msg.getSettledAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    currency: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    payment: (f = msg.getPayment()) && accounts_protos_payment_dto_pb.PaymentDTO.toObject(includeInstance, f),
    relations: (f = msg.getRelations()) && proto.accounts.protos.InvoiceRelationsDTO.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.accounts.protos.InvoiceItemDTO.toObject, includeInstance),
    stripeData: (f = msg.getStripeData()) && proto.accounts.protos.InvoiceDataStripeDTO.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.InvoiceDTO}
 */
proto.accounts.protos.InvoiceDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.InvoiceDTO;
  return proto.accounts.protos.InvoiceDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.InvoiceDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.InvoiceDTO}
 */
proto.accounts.protos.InvoiceDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSettledAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 7:
      var value = new accounts_protos_payment_dto_pb.PaymentDTO;
      reader.readMessage(value,accounts_protos_payment_dto_pb.PaymentDTO.deserializeBinaryFromReader);
      msg.setPayment(value);
      break;
    case 8:
      var value = new proto.accounts.protos.InvoiceRelationsDTO;
      reader.readMessage(value,proto.accounts.protos.InvoiceRelationsDTO.deserializeBinaryFromReader);
      msg.setRelations(value);
      break;
    case 9:
      var value = new proto.accounts.protos.InvoiceItemDTO;
      reader.readMessage(value,proto.accounts.protos.InvoiceItemDTO.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 10:
      var value = new proto.accounts.protos.InvoiceDataStripeDTO;
      reader.readMessage(value,proto.accounts.protos.InvoiceDataStripeDTO.deserializeBinaryFromReader);
      msg.setStripeData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.InvoiceDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.InvoiceDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.InvoiceDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSettledAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPayment();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      accounts_protos_payment_dto_pb.PaymentDTO.serializeBinaryToWriter
    );
  }
  f = message.getRelations();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.accounts.protos.InvoiceRelationsDTO.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.accounts.protos.InvoiceItemDTO.serializeBinaryToWriter
    );
  }
  f = message.getStripeData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.accounts.protos.InvoiceDataStripeDTO.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.accounts.protos.InvoiceDTO.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.accounts.protos.InvoiceDTO.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.setType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.accounts.protos.InvoiceDTO.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.setLabel = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearLabel = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasLabel = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.InvoiceDTO.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
*/
proto.accounts.protos.InvoiceDTO.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp settled_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.InvoiceDTO.prototype.getSettledAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
*/
proto.accounts.protos.InvoiceDTO.prototype.setSettledAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearSettledAt = function() {
  return this.setSettledAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasSettledAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string currency = 6;
 * @return {string}
 */
proto.accounts.protos.InvoiceDTO.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.setCurrency = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearCurrency = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PaymentDTO payment = 7;
 * @return {?proto.accounts.protos.PaymentDTO}
 */
proto.accounts.protos.InvoiceDTO.prototype.getPayment = function() {
  return /** @type{?proto.accounts.protos.PaymentDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_payment_dto_pb.PaymentDTO, 7));
};


/**
 * @param {?proto.accounts.protos.PaymentDTO|undefined} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
*/
proto.accounts.protos.InvoiceDTO.prototype.setPayment = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearPayment = function() {
  return this.setPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasPayment = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional InvoiceRelationsDTO relations = 8;
 * @return {?proto.accounts.protos.InvoiceRelationsDTO}
 */
proto.accounts.protos.InvoiceDTO.prototype.getRelations = function() {
  return /** @type{?proto.accounts.protos.InvoiceRelationsDTO} */ (
    jspb.Message.getWrapperField(this, proto.accounts.protos.InvoiceRelationsDTO, 8));
};


/**
 * @param {?proto.accounts.protos.InvoiceRelationsDTO|undefined} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
*/
proto.accounts.protos.InvoiceDTO.prototype.setRelations = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearRelations = function() {
  return this.setRelations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasRelations = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated InvoiceItemDTO items = 9;
 * @return {!Array<!proto.accounts.protos.InvoiceItemDTO>}
 */
proto.accounts.protos.InvoiceDTO.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.accounts.protos.InvoiceItemDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accounts.protos.InvoiceItemDTO, 9));
};


/**
 * @param {!Array<!proto.accounts.protos.InvoiceItemDTO>} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
*/
proto.accounts.protos.InvoiceDTO.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.accounts.protos.InvoiceItemDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.InvoiceItemDTO}
 */
proto.accounts.protos.InvoiceDTO.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.accounts.protos.InvoiceItemDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional InvoiceDataStripeDTO stripe_data = 10;
 * @return {?proto.accounts.protos.InvoiceDataStripeDTO}
 */
proto.accounts.protos.InvoiceDTO.prototype.getStripeData = function() {
  return /** @type{?proto.accounts.protos.InvoiceDataStripeDTO} */ (
    jspb.Message.getWrapperField(this, proto.accounts.protos.InvoiceDataStripeDTO, 10));
};


/**
 * @param {?proto.accounts.protos.InvoiceDataStripeDTO|undefined} value
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
*/
proto.accounts.protos.InvoiceDTO.prototype.setStripeData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.accounts.protos.InvoiceDTO.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.InvoiceDTO} returns this
 */
proto.accounts.protos.InvoiceDTO.prototype.clearStripeData = function() {
  return this.setStripeData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceDTO.prototype.hasStripeData = function() {
  return jspb.Message.getField(this, 10) != null;
};


goog.object.extend(exports, proto.accounts.protos);
